/* src/app/modules/patternmatch/components/pattern-match/pattern-match.component.scss */
:host {
  box-shadow: var(--shadow-raised);
  transition: var(--transition-time) all ease-in-out;
  border-radius: var(--sh-card-border-radius);
  --bar-color-01-light: rgba(61, 195, 176, 0.15);
  background-color: var(--base-3);
  color: var(--text-secondary);
  display: flex;
  flex-direction: column;
  padding: 1rem;
  border-radius: var(--border-radius-medium);
}
api-call-gate,
:host {
  display: flex;
  flex-direction: column;
}
api-call-gate {
  justify-content: center;
  min-height: 300px;
  flex: 1 0;
}
.header {
  display: flex;
  flex-direction: row;
}
.header sh-text {
  flex: 1 0;
}
.header .tag-container {
  flex: 1 0;
  display: flex;
  max-width: 50%;
  overflow: hidden;
}
.header sh-tag {
  margin-left: auto;
  max-width: 100%;
  background-color: var(--bar-color-01-light);
}
sh-text {
  margin-bottom: 1rem;
}
.chart {
  padding: 1rem;
  background-color: rgba(var(--ui-1), 0.03);
}
.table {
  padding: 1rem;
}
.last-update {
  display: flex;
  flex-direction: row;
}
.last-update span {
  font: var(--body-2);
  color: var(--text-secondary);
  margin-left: auto;
}
.tag-container {
  flex: 1 0;
  min-height: 2rem;
  display: flex;
}
[screen-phone] :host-context .header {
  max-width: 100%;
  flex-direction: column;
  padding-bottom: 1rem;
}
[screen-phone] :host-context .header .tag-container {
  max-width: 100%;
}
[screen-phone] :host-context .header .tag-container sh-tag {
  margin-left: auto;
  max-width: 100%;
}
.empty {
  padding: 1rem;
  display: flex;
  min-height: 200px;
  flex-direction: column;
  font: var(--body-1);
  align-items: center;
}
.empty > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  gap: 1rem;
}
.empty > div > span {
  text-align: center;
}
.empty app-back-to-system-overview {
  margin-top: 1rem;
  display: initial;
}
.mrq-header-text {
  margin-block-start: 1rem;
}
.mrq-button-container {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-block-end: 1rem;
  cursor: pointer;
}
.mrq-dashboard-button {
  margin-left: auto;
}
/*# sourceMappingURL=pattern-match.component.css.map */
